import { ViewModel,View, ObservableArray, ViewModelMessage, Binder } from "binder"
import { data } from "jquery";
import { BindingConverterResolver } from "src/binder/parser/prototype/bindingPrototype";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { DataModel } from "src/formBuilder/datamodel/structure";
import { Converters } from "../templateEditor/structureView/converters";
import { TemplateEditorViewModel } from "../templateEditor/templateEditor-viewModel";
import { MediaTypes, NoMediaTemplateViewModel, TemplateListViewModel, TemplateViewModel } from "../templateList/templateList-viewModel";
import { ViewModelBuilderViewModel } from "../viewModelBuilder/viewModelBuilder-viewModel";
import  { FormBuilderView } from "./formBuilder-view"
import { PreviewFormBuilderFormMessage } from "../formBuilderWindow-viewModel";

export class GetAllTemplateMessage extends ViewModelMessage{
    
}
export class GetAllNoMediaTemplateMessage extends ViewModelMessage{
    
}

export class FormBuilderViewModel extends ViewModel{
    
    private static isConvertersAdded :boolean = false;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        
        if(FormBuilderViewModel.isConvertersAdded==false){
            FormBuilderViewModel.isConvertersAdded=true;
            BindingConverterResolver.converterRepository.push(new Converters());
        }
        this.partName = 'Form Builder';
        this.editor = new TemplateEditorViewModel(this);
        this.dataModel = new DataModel(this);
        this.templateList = new TemplateListViewModel(this);
    }

    public getTypeId(): string {
        return '251F7ED5-C169-4B3F-BC02-E8766D2607E2';
    }
    public GetDefaultView(): View<ViewModel> {
        return new FormBuilderView();
    }
    
    hasUnsavedChanges():boolean{
        return this.editor.hasUnsavedChanges();
    }
    async checkEditingAllowance() : Promise<boolean> {
        if(this.hasUnsavedChanges()){
            let confirmationResult = await this.messageBoxWarningYesNo('Do you want to save data?','Saving');
            if(confirmationResult=='yes'){
                return Promise.resolve(false);
            }else{
                this.editor.rejectChanges();
                return Promise.resolve(true);
            }
        }else{
            return Promise.resolve(true);
        }
    }
    dispose(){
        this.rejectChanges();
    }
    rejectChanges(){
        this.editor?.rejectChanges();
    }
    public set templateList(v: TemplateListViewModel) { this._templateList = v; } public get templateList(): TemplateListViewModel { return this._templateList;} private _templateList: TemplateListViewModel;
    public set editor(v: TemplateEditorViewModel) { this._editor = v; } public get editor(): TemplateEditorViewModel { return this._editor;} private _editor: TemplateEditorViewModel;
    public set dataModel(v: DataModel) { this._dataModel = v; } public get dataModel(): DataModel { return this._dataModel;} private _dataModel: DataModel;
    public set partName(v: string) { this._partName = v; } public get partName(): string { return this._partName;} private _partName: string;
    
            
    private _lastEditingTemplate: TemplateViewModel;
    private _lastEditingMediaType:MediaTypes;

    editTemplate(template: TemplateViewModel,mediaType:MediaTypes) : Promise<boolean> {
        this._lastEditingTemplate = template;
        this._lastEditingMediaType = mediaType;
        return this.editor.edit(template,null,mediaType)
    }
    
    override handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllTemplateMessage){
            return [...this.templateList.templates];
        }else if(msg instanceof GetAllNoMediaTemplateMessage){
            return [...this.templateList.noMediaTemplates];
        }else if(msg instanceof PreviewFormBuilderFormMessage){
            let allTemplates = this.serailize();
            let relatedTemplate = allTemplates.Templates.filter(x=>x.Name==this._lastEditingTemplate.name && x.MediaType==this._lastEditingMediaType).at(0);
            if(relatedTemplate==null){
                relatedTemplate = {};
                allTemplates.Templates.push(relatedTemplate);
            }
            relatedTemplate.Name = this._lastEditingTemplate.name;
            relatedTemplate.ClassName = this._lastEditingTemplate.dataModelClass.name;
            relatedTemplate.Json = msg.currentJsonInfo;
            relatedTemplate.Html = msg.currentHtml;
            relatedTemplate.IsMain = false;
            relatedTemplate.IsDetail = false;
            relatedTemplate.MediaType = this._lastEditingMediaType;
            msg.allTemplates = allTemplates;
            msg.toShowTemplate = relatedTemplate;
            return super.handleMessage(msg);
        }else{
            return super.handleMessage(msg);
        }
    }

    serailize():any{
        return {
            Templates : this.templateList.templates.map(x=>{
                return {
                    Name : x.name,
                    ClassName : x.dataModelClass.name,
                    Json : x.jsonInfo,
                    Html : x.htmlContent,
                    IsMain : x.isMain,
                    IsDetail : x.isDetail,
                    MediaType : <number>x.mediaType
                };
            })
        }
    }

    deserialize(info:any){
        let templates : TemplateViewModel[] = info.Templates.map(x=>{
            let template = new TemplateViewModel(this.templateList);
            template.name = x.Name;
            template.dataModelClass = this.dataModel.classes.filter(y=>y.name==x.ClassName)[0];
            template.jsonInfo = x.Json;
            template.isMain = x.IsMain;
            template.isDetail = x.IsDetail;
            template.mediaType = x.MediaType ?? MediaTypes.default;
            template.updateTemplateHtml(x.Html);
            return template;
        });
        templates.forEach(x=>{
            let relatedNoMediaTemplate = this.templateList.noMediaTemplates.filter(y=>y.name==x.name).at(0);
            if(relatedNoMediaTemplate==null){
                relatedNoMediaTemplate = new NoMediaTemplateViewModel(this);
                relatedNoMediaTemplate.name = x.name;
                relatedNoMediaTemplate.dataModelClass = x.dataModelClass;
                relatedNoMediaTemplate.isMain = x.isMain;
                relatedNoMediaTemplate.isDetail = x.isDetail;
                this.templateList.noMediaTemplates.push(relatedNoMediaTemplate);
            }
            relatedNoMediaTemplate.templates.push(x);
        })
        this.templateList.templates.update(...templates);
    }

    updateModelFromJson(json){
        let dataModel = new DataModel(this);
        dataModel.Parse(json);
        dataModel.generateClasses(this,false);
        this.dataModel = dataModel;
    }
}

